const PREFIX = 'persist:';

export class CookieStorage {
  constructor(cookies, { setCookieOptions = {}, expiration = {} } = {}) {
    this.cookies = cookies;
    this.setCookieOptions = setCookieOptions;
    this.expiration = expiration;
  }

  getItem(key) {
    return Promise.resolve(this.cookies.get(`${PREFIX}${key}`) || null);
  }

  setItem(key, value) {
    const expires = this.expiration?.default;
    this.cookies.set(`${PREFIX}${key}`, value, {
      ...this.setCookieOptions,
      ...(expires ? { expires: new Date(Date.now() + expires) } : {}),
    });
    return Promise.resolve();
  }

  removeItem(key) {
    this.cookies.expire(`${PREFIX}${key}`, this.setCookieOptions);
    return Promise.resolve();
  }
}
